import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { QaiFloatingDirective, QaiIconComponent, QaiTooltipComponent } from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  imports: [CommonModule, QaiIconComponent, QaiTooltipComponent, QaiFloatingDirective, TranslocoModule],
  selector: 'app-call-header',
  standalone: true,
  styleUrls: ['./call-header.css'],
  templateUrl: './call-header.html',
})
export class CallHeaderComponent {
  @Input({ required: true }) title!: string | undefined;
  @Input({ required: true }) sessionId!: string | undefined;
  @Input() isLoading = false;

  @Output() readonly sessionIdClicked = new EventEmitter();

  protected handleSessionIdClick() {
    this.sessionIdClicked.emit();
  }

  @HostBinding('class')
  protected get cssClass() {
    return {
      isLoading: !!this.isLoading,
    };
  }
}
